export default __webpack_public_path__ + "static/media/gear_white.76ce4e83.svg";